$(function () {


	// this tries to find which of the shopify option script select boxes 
	// the input belongs to, once it's found then it selects that otherwise nothing.
	function matchOptions(option) {
		$('.single-option-selector option').each(function () {
			if ($(this).val() == option) {
				$(this).prop('selected', true);
			}
		});

	}

	function cartNotification() {

		$('.j-cart-notification').addClass('active');

		setTimeout(function () {

			$('.j-cart-notification').removeClass('active');

		}, 3000);

	};

	// Toggle flavour variants
	$(document).on('click', '.flavour-list a', function (e) {
		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');
		var bgcolor = $(this).css('background-color')
		var flavour_color = bgcolor.replace('rgb', 'rgba').replace(')', ',0.2)');
		$('.product-template').css('background', 'linear-gradient(to bottom, ' + flavour_color + ', #fff 1000px)');

		// new options script
		var option = $(this).data('option');
		matchOptions(option);
		$('.single-option-selector').trigger('change');
		// end

	});

	// Set cost per serving on load

	var cps = $('.j-id').find('option:selected').data('cost-per-serving');
	$('.j-update-cps').text(cps);

	$('.shopify-product-form').each(function () {
		var first_price = $(this).find('.j-id').find('option:selected').data('price');
		$(this).find('.j-variant-price').text(first_price);


	});

	// var first_price = $('.j-id').find('option:selected').data('price');
	// $('.j-variant-price').text(first_price);

	// Main select ID filter

	// function append_tp_reviews(sku){
	// 	$('.product-reviews').append("<div class=\"tp-wrapper\"></div>");
	// 	$('.tp-wrapper').html("<div class=\"trustpilot-widget\" data-locale=\"en-GB\" data-template-id=\"54d39695764ea907c0f34825\" data-businessunit-id=\"5db30d76705460000174cfd9\" data-style-height=\"24px\" data-style-width=\"100%\" data-theme=\"light\" data-sku=\"1231232"+sku+"\"><a href=\"https://uk.trustpilot.com/review/highfive.co.uk\" target=\"_blank\" rel=\"noopener\">Trustpilot</a></div>");
	// }

	//    function reload_js(src) {
	//        $('script[src="' + src + '"]').remove();
	//        $('<script async>').attr('src', src).appendTo('head');
	//    }	

	$(document).on('filter', '.j-id', function () {
		const form = $(this).closest('form')
		$(this).find('option').prop('disabled', true);

		// var skuFilter = $(this).data('variant-sku') ? '' + $(this).data('variant-sku') + '' : '';

		var sizeFilter = $(this).data('filtered-size') ? '[data-size=' + $(this).data('filtered-size') + ']' : '';
		var flavourFilter = $(this).data('filtered-flavour') ? '[data-flavour=' + $(this).data('filtered-flavour') + ']' : '';
		$(this).find('option' + flavourFilter).prop('disabled', false);

		$(this).closest('form').find('.size-list a').addClass('disabled').find('.j-variant-price').text('Sold Out');

		$(this).find('option' + flavourFilter + sizeFilter + ':enabled:first').prop('selected', true);

		$(this).find('option:enabled').each(function () {
			if($(this).attr("data-sold-out") != 'true') {
				$(this).closest('form').find('.size-list a[data-size=' + $(this).data('size') + ']').removeClass('disabled').find('.j-variant-price').text($(this).data('price'));
			}
		});

		// Back-in-stock notify form (scoped to this card/PDP context).
		var $ctx = $(this).closest('.product-item, .product-template');
		var $bis = $ctx.find('.back-in-stock-form');
		// The CTA to hide when sold out: the card's CTA inner (qty + button),
		// else (PDP) the button plus the separate quantity selector.
		var $cta = $ctx.find('.product-card-nov24__cta-row-inner');
		if (!$cta.length) $cta = form.find('.add-to-cart-btn').closest('.cell').add($ctx.find('.qty-selector').closest('.cell'));
		// Keep the Klaviyo list id in sync with the selected variant.
		$bis.find('[data-klaviyo-list-id-input]').val($(this).find('option:selected').data('klaviyo-list-id') || '');

		if ($(this).find('option:selected').attr("data-sold-out") === 'true') {
			form.find('.add-to-cart-btn').prop('disabled', true);
			form.find('.add-to-cart-btn [data-oos]').show();
			form.find('.add-to-cart-btn [data-in-stock]').hide();
			if ($bis.length) {
				$cta.hide();
				$bis.show();
			}
			return
		} else {
			form.find('.add-to-cart-btn').prop('disabled', false);
			form.find('.add-to-cart-btn [data-oos]').hide();
			form.find('.add-to-cart-btn [data-in-stock]').show();
			if ($bis.length) {
				$cta.show();
				$bis.hide();
			}
		}


		$(this).closest('form').find('.size-list a[data-size=' + $(this).find('option:selected').data('size') + ']').addClass('active').siblings().removeClass('active');

		// Get selected option cost per serving and update
		var cps = $(this).find('option:selected').data('cost-per-serving');
		$(this).closest('form').find('.j-update-cps').text(cps);

		// Get selected option price and update
		var vprice = $(this).find('option:selected').data('price');
		$(this).closest('form').find('.j-update-compare-at-price').text(vprice);

		// Get selected option compare-at-price and update
		var vcompareprice = $(this).find('option:selected').data('compare-at-price');
		$(this).closest('form').find('.j-update-price').text(vcompareprice);

		var vsize = $(this).find('option:selected').data('size-human');
		$(this).closest('form').find('.j-change-size').text(vsize);

		var vflavour = $(this).find('option:selected').data('flavour-human');
		$(this).closest('form').find('.j-change-flavour').text(vflavour);

		var variant_value = $(this).find('option:selected').val();
		$(this).closest('form').find('.add-to-cart-btn').val(variant_value);

		var variant_img = $(this).find('option:selected').data('variant-img');

		$('.j-p-carousel .item[data-img-src="' + variant_img + '"]').click();

		// Start trade discount logic

		if ($(this).hasClass('hasTradeDiscount')) {

			$(this).find('option:enabled').each(function () {

				var vprice_value = $(this).data('variant-price');
				var discount = $(this).data('trade-discount');
				var discountedPrice = vprice_value - (vprice_value * (discount / 100));
				var discountedPriceValue = (discountedPrice / 100).toFixed(2);
				$(this).closest('form').find('.size-list a[data-size=' + $(this).data('size') + ']').find('.j-variant-price').text('£' + discountedPriceValue);

			});

			var active_trade_price = $('.j-select-size.active .j-variant-price').text();
			$('.j-update-compare-at-price').text(active_trade_price);

		}

	})

	// On variant chnage

	$(document).on('click', '.j-select-size, .j-select-flavour', function (e) {
		e.preventDefault();
		console.log("CLICK ON: j-select-size or j-select-flavour")
		if ($(this).data('size')) {
			// filter by size
			$(this).closest('form').find('.j-id').data('filtered-size', $(this).data('size'));
		}

		if ($(this).data('flavour')) {
			// filter by flavour
			$(this).closest('form').find('.j-id').data('filtered-flavour', $(this).data('flavour'));
			$(this).closest('form').find('.j-id').data('filtered-size', '');

			// Change slick bg on flavour change

			const slickFlavour = $(this).data('flavour');
			const productCard = this.closest('.product-item')
			setProductCardFlavourColor(productCard, slickFlavour)

		}

		// new options script
		var option = $(this).data('option');
		matchOptions(option);
		$('.single-option-selector').trigger('change');
		// end

		$(this).closest('form').find('.j-id').trigger('filter');

	});

	$('.j-select-size.first-size, .j-select-flavour.first-flav').trigger('click'); //This is preventing the specific variant change upon load since it always selects first child..

	// Slick product carousel bg set

	$('.product-item .flavour-list').each(function () {

		var slickFlavour = $(this).find('.j-select-flavour').data('flavour');
		const productCard = this.closest('.product-item')
		setProductCardFlavourColor(productCard, slickFlavour)

	});



	// Cart JS functions


	$(document).on('click', '.add-to-cart-btn', function (e) {

		e.preventDefault();

		var btn = $(this);
		var id = $(this).val(); // Get product variant ID from variant
		var quantity = $(this).closest('.shopify-product-form').find(".j-update-qty").val();

		var productData = btn.closest('.shopify-product-form').find('.j-id').find('option').filter(function() {
			return $(this).val() === id; // Check if the option's value matches
		});

		sendDataLayer(productData, quantity, 'add');

		CartJS.addItem(id, quantity, {}, {
			"success": function (data, textStatus, jqXHR) {

				if (!btn.hasClass('trade-button')) {

					$('.j-toggle-cart').trigger('click');

				} else {

					var url = window.location.href + '?cart=open';

					setTimeout(function () {

						window.location.replace(url);

					}, 1000);

				}

				cartNotification();

			},
			"error": function (jqXHR, textStatus, errorThrown) {
				console.log('Error: ' + errorThrown + '!');
			}
		});

	});


	$(document).on('click', '.cart_item .qty-selector span', function () {

		var qty_input = $(this).parent().find('input');
		var counter = parseInt(qty_input.val());

		if ($(this).hasClass('minus')) {

			var type = 'remove'

			if (qty_input.val() < 2) {
				console.log('smaller than 0');
			} else {

				counter--;
				qty_input.val(counter);

			}

			var itemID = $(this).parent().data('vid');

			setTimeout(function () {
				CartJS.updateItemById(itemID, counter);
			}, 500);

		}

		if ($(this).hasClass('plus')) {

			var type = 'add'
			counter++;
			qty_input.val(counter);

			var itemID = $(this).parent().data('vid');

			setTimeout(function () {
				CartJS.updateItemById(itemID, counter);
			}, 500);

		}

		var productData = $(this).closest('.cart_item')

		sendDataLayer(productData, 1, type);
		
	});

	$(document).on('click', '.j-remove-product', function (e, cart) {

		e.preventDefault();
		var vid = $(this).data('vid');
		CartJS.removeItemById(vid);
		$(this).closest('.cart_item').fadeOut();

		var productData = $(this).closest('.cart_item')

		console.log(productData);

		sendDataLayer(productData, $(this).closest('.cart_item').find('input').val(), 'remove');

	});

	$(document).on('cart.requestComplete', function (event, cart) {

		cartRequestComplete();

	});

	function cartRequestComplete() {

		$('.cart_contents_wrapper').load('/ .cart_contents', function () {

			if (!$('.add-to-cart-btn').hasClass('trade-button')) {

				$('.site-header').addClass('cart-active');
				$('.j-toggle-cart, .cart-sidebar').addClass('active');

			}

			jQuery.getJSON('/cart.js', function (cart) {
				//$('.j-toggle-cart').text( cart.item_count );
				window.cart = cart
			});

		});

	}

	// Open cart on redirect

	if (document.location.href.indexOf('cart=open') > -1) {

		//cartRequestComplete();
		$('.j-toggle-cart').click();

	}

	$(document).on('click', '.j-add-account-upsell', function (e) {

		e.preventDefault();

		var btn = $(this);
		var id = $(this).data('id'); // Get product variant ID from variant
		var quantity = 1;

		var productData = btn.closest('.item').find('.j-id').find('option').filter(function() {			
			return parseInt($(this).val()) === parseInt(id); // Check if the option's value matches
		});
		
		console.log(productData);
		sendDataLayer(productData, quantity, 'add');

		CartJS.addItem(id, quantity, {}, {
			"success": function (data, textStatus, jqXHR) {
				cartNotification();
			},
			"error": function (jqXHR, textStatus, errorThrown) {
				console.log('Error: ' + errorThrown + '!');
			}
		});

		if (btn.hasClass('trade-button')) {

			var url = window.location.href + '?cart=open';

			setTimeout(function () {

				window.location.replace(url);

			}, 1000);

		}

	});

});

function setProductCardFlavourColor(productCard, flavour) {
	let flavour_rgb = $('.pf-' + flavour).css('background-color');
	if (!flavour_rgb) return;
	productCard?.style.setProperty('--flavour-color', flavour_rgb);
}

function sendDataLayer(productData, quantity, type) {
	if (type == 'add') {
		eventName = 'add_to_cart'
	} else {
		eventName = 'remove_from_cart'
	}

	window.dataLayer = window.dataLayer || [];
	dataLayer.push({
		event: 'ecom_events',
		event_name: eventName,
		ecommerce: {
			currency: 'GBP',
			value: productData.data('variant-price') * quantity / 100, 
			coupon: window.cartDiscount,
			items: [
				{
					item_id: productData.data('variant-sku').toString(),
					item_name: productData.data('product-title'),
					item_variant: productData.data('variant-title'),
					item_category: productData.data('type'),
					price: productData.data('variant-price') / 100,
					quantity: quantity
				}
			]
		}
	});
}
